import React from "react";
import Storelist from "../../Store/Actions";
import { IoWarningOutline } from "react-icons/io5";
import ReactStars from "react-rating-stars-component";
import { seviceStatuses } from "../../appconfig";
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

const index = ({ data, TaskHandler }) => {
  const { ServiceDetailsStore } = Storelist();
  const serviceDetail = ServiceDetailsStore?.data;
  const item = { ...data };
  return (
    <>
      <button
        data-tooltip-id={`tooltip-${item?._id}`}
        data-tooltip-content={item?.isTechnicianAbsent?.message}
        key={index}
        onClick={() => TaskHandler(item?._id)}
        className={`action-btn-item 
                      ${
                        serviceDetail?.bikeRequest?._id === item?._id
                          ? "active"
                          : ""
                      } 
                      ${
                        item.isTechnicianAbsent?.availability
                          ? "incomplete"
                          : ""
                      }`}
      >
        {item?.isTechnicianAbsent.availability && (
          <div className="incomplete">
            <IoWarningOutline />
          </div>
        )}
        <div className="name">
          <p>{item?.customerName}</p>
          <p>
            <i
              className={
                item?.serviceType?.serviceTypeCode === "IPDS"
                  ? `fa-solid fa-house`
                  : item?.serviceType?.serviceTypeCode === "IDIS"
                  ? "fa-solid fa-person-walking"
                  : "fa-solid fa-shop"
              }
            ></i>
          </p>
        </div>

        <p className="date">
          <p className="flex flex-col justify-center items-center">
            {item?.slotBooked?.split("T")[0]?.split("-")?.reverse()?.join("-")}
          </p>
          {item?.serviceStatus === seviceStatuses.delivered && (
            <p>
              <ReactStars
                count={5}
                size={10}
                activeColor={item?.ratingId?.rating > 3 ? "#ffd700" : "#ff0000"}
                half={true}
                value={item?.ratingId?.rating}
                edit={false}
              />
            </p>
          )}
        </p>

        {item?.amcId !== null && (
          <img
            src="/images/amc_logo.png"
            alt="Amc service"
            width={20}
            className=""
          />
        )}
        {item?.warrantyId  && (
          <img
            src="/images/warranty_logo.png"
            alt="Free Service"
            width={20}
            className=""
          />
        )}
      </button>
      {item?.isTechnicianAbsent?.availability && <Tooltip id={`tooltip-${item?._id}`} place="top" />}
    </>
  );
};

export default index;
